import { Routes } from '@angular/router';
import { AuthGuard, BugBountyAuthGuard, BugBountyNoAuthGuard, NoAuthGuard, SAFAuthGuard, SAFManifestAuthGuard } from './auth/auth.gaurd';
import { amcGuard } from './auth/amc.guard';

export const routes: Routes = [
  // { path: '', loadComponent: () => import('../app/contribution/contribution.component').then(c => c.ContributionComponent) },
  { path: '', loadComponent: () => import('../app/foire-annonce/foire-annonce-page.component').then(c => c.FoireAnnoncePageComponent) },
  {
    path: 'philosophy',
    children: [
      {
        path: '',
        loadComponent: () => import('../app/philosophy-hub/philosophy-hub.component').then(c => c.PhilosophyHubComponent)
      },
      {
        path: 'trade-on-aoc-pancakeswap',
        loadComponent: () => import('../app/philosophy-hub/components/trade-on-aoc-pancakeswap/trade-on-aoc-pancakeswap.component').then(c => c.TradeOnAocPancakeswapComponent)
      }
    ]
  },
  { path: 'audit-report', loadComponent: () => import('../app/audit-report/audit-report.component').then(c => c.AuditReportComponent) },
  { path: 'docs', loadComponent: () => import('../app/docs/docs.component').then(c => c.DocsComponent) },
  { path: 'ecosystem', loadChildren: () => import('./ecosystem/ecosystem.routes').then(m => m.routes) },
  { path: 'saf-dashboard', loadComponent: () => import('../app/saf-aoc/saf-aoc-page.component').then(c => c.SafAocPageComponent) },
  { path: 'contribution', loadComponent: () => import('../app/foire-annonce/foire-annonce-page.component').then(c => c.FoireAnnoncePageComponent) },
  { path: 'faq', loadComponent: () => import('../app/faq/faq.component').then(c => c.FaqComponent) },
  { path: 'partners', loadComponent: () => import('../app/partners/partners.component').then(c => c.PartnersComponent) },
  { path: 'blog', loadComponent: () => import('../app/blog/blog.component').then(c => c.BlogComponent) },
  { path: 'blog-detail/:id', loadComponent: () => import('../app/blog-detail/blog-detail.component').then(c => c.BlogDetailComponent) },
  // { path: 'contribution', loadComponent: () => import('../app/contribution/contribution.component').then(c => c.ContributionComponent) },
  { path: 'wallet-connect', loadComponent: () => import('../app/dashbaord/wallet-connect/wallet-connect.component').then(c => c.WalletConnectComponent) },
  { path: 'signup', canActivate: [NoAuthGuard], loadComponent: () => import('../app/dashbaord/signup/signup.component').then(c => c.SignupComponent) },
  { path: 'user-dashboard', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/dashboard/dashboard.component').then(c => c.DashboardComponent) },
  { path: 'contributenow', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/buynow/buynow.component').then(c => c.BuynowComponent) },
  { path: 'user-profile', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/profile/profile.component').then(c => c.ProfileComponent) },
  { path: 'my-referral', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/profile/myrefferal/myrefferal.component').then(c => c.MyrefferalComponent) },
  // { path:'top-sponsors-list', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/leaderboard/leaderboard.component').then(c => c.LeaderboardComponent)},
  // { path:'top-sponsors', loadComponent: () => import('../app/dashbaord/header-leaderboard/header-leaderboard.component').then(c => c.HeaderLeaderboardComponent)},
  // { path:'top-countries-list', loadComponent: () => import('../app/dashbaord/top-countries/top-countries.component').then(c => c.TopCountriesComponent)},
  // { path:'top-countries', loadComponent: () => import('../app/dashbaord/header-top-country/header-top-country.component').then(c => c.HeaderTopCountryComponent)},
  { path: 'privacy-policy', loadComponent: () => import('../app/dashbaord/privacy-policy/privacy-policy.component').then(c => c.PrivacyPolicyComponent) },
  // { path: 'aoc-chat-bot', loadComponent: () => import('../app/shared/component/chatbot-page/chatbot-page.component').then(c => c.ChatbotPageComponent) },
  // {path:'miracle-matrix', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/miracle-matrix/miracle-matrix.component').then(c => c.MiracleMatrixComponent)},
  {
    path: 'collaborative-contribution',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/collaborative-contribution/collaborative-contribution.component').then(c => c.CollaborativeContributionComponent)
      },
      {
        path: 'form',
        loadComponent: () => import('../app/dashbaord/collaboration-form/collaboration-form.component').then(c => c.CollaborationFormComponent)
      },
      {
        path: 'invalid-list',
        loadComponent: () => import('../app/dashbaord/collaborative-contribution/invalid-collaborative-details/invalid-collaborative-details.component').then(c => c.InvalidCollaborativeDetailsComponent)
      },
      {
        path: 'update/:collabrative_id',
        loadComponent: () => import('../app/dashbaord/collaborative-contribution/invalid-collaboration-update-form/invalid-collaboration-update-form.component').then(c => c.InvalidCollaborationUpdateFormComponent)
      },
      {
        path: 'internal',
        loadComponent: () => import('../app/dashbaord/internal-id-collaborative/internal-id-collaborative.component').then(c => c.InternalIdCollaborativeComponent)
      },
      {
        path: 'internal/form',
        loadComponent: () => import('../app/dashbaord/internal-id-collaborative/internal-id-collaborative-form/internal-id-collaborative-form.component').then(c => c.InternalIdCollaborativeFormComponent)
      },
      {
        path: 'aggressive-marketing',
        canActivate: [amcGuard],
        loadComponent: () => import('../app/dashbaord/aggressive-marketing/aggressive-marketing-collaborative/aggressive-marketing-collaborative.component').then(c => c.AggressiveMarketingCollaborativeComponent)
      },
      {
        path: 'aggressive-marketing/form',
        canActivate: [amcGuard],
        loadComponent: () => import('../app/dashbaord/aggressive-marketing/aggressive-marketing-collaborative-form/aggressive-marketing-collaborative-form.component').then(c => c.AggressiveMarketingCollaborativeFormComponent)
      },
      // {
      //   path: 'saf-list',
      //   canActivate: [SAFAuthGuard],
      //   loadComponent: () => import('../app/dashbaord/saf-contribution/saf-collaborative-contribution/saf-collaborative-contribution.component').then(c => c.SafCollaborativeContributionComponent)
      // },
      // {
      //   path: 'saf/form',
      //   canActivate: [SAFAuthGuard],
      //   loadComponent: () => import('../app/dashbaord/saf-contribution/saf-collaboraive-form/saf-collaboraive-form.component').then(c => c.SafCollaboraiveFormComponent)
      // },
      // {
      //   path: 'saf-manifestation-space',
      //   // canActivate: [SAFAuthGuard,SAFManifestAuthGuard],
      //   loadComponent: () => import('../app/dashbaord/saf-contribution/saf-manifestation-space/saf-manifestation-space.component').then(c => c.SafManifestationSpaceComponent)
      // },
      {
        path: 'saf-aoc-token-list',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/saf-contribution/saf-aoc-token-registration-list/saf-aoc-token-registration-list.component').then(c => c.SafAocTokenRegistrationListComponent)
      },
      {
        path: 'saf-aoc-token/form',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/saf-contribution/saf-aoc-token-registration-form/saf-aoc-token-registration-form.component').then(c => c.SafAocTokenRegistrationFormComponent)
      },
      {
        // Mentor-facing family rename requests. SAFAuthGuard is the African-user check.
        path: 'family-name-management',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/family-name-management/family-name-management.component').then(c => c.FamilyNameManagementComponent)
      },
      {
        path: 'post-saf-aoc',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/saf-contribution/post-saf-aoc/post-saf-aoc-directory/post-saf-aoc-directory.component').then(c => c.PostSafAocDirectoryComponent)
      },
      {
        // Initiative 65 has its own registration component; 66-67 share the non-token form below.
        path: 'post-saf-aoc/initiative-65/form',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/saf-contribution/post-saf-aoc/post-saf-initiative-65-registration-form/post-saf-initiative-65-registration-form.component').then(c => c.PostSafInitiative65RegistrationFormComponent)
      },
      {
        path: 'post-saf-aoc/non-token/form',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/saf-contribution/post-saf-aoc/post-saf-non-token-registration-form/post-saf-non-token-registration-form.component').then(c => c.PostSafNonTokenRegistrationFormComponent)
      },
      {
        path: 'post-saf-initiative-rewards/list',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/saf-contribution/post-saf-aoc/post-saf-initiative-rewards-list/post-saf-initiative-rewards-list.component').then(c => c.PostSafInitiativeRewardsListComponent)
      },
      {
        path: 'post-saf-initiative-rewards/contributed',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/saf-contribution/post-saf-aoc/post-saf-initiative-rewards-list/post-saf-initiative-rewards-list.component').then(c => c.PostSafInitiativeRewardsListComponent)
      },
      {
        path: 'post-saf-aoc/token/form',
        canActivate: [SAFAuthGuard],
        loadComponent: () => import('../app/dashbaord/saf-contribution/post-saf-aoc/post-saf-aoc-token-registration-form/post-saf-aoc-token-registration-form.component').then(c => c.PostSafAocTokenRegistrationComponent)
      }
    ]
  },
  { path: 'flash-operation', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/flash-operation/flash-operation.component').then(c => c.FlashOperationComponent) },
  { path: 'contribuezmaintenant', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/buynow/buynow.component').then(c => c.BuynowComponent) },
  { path: 'contribution-user-details', canActivate: [AuthGuard], loadComponent: () => import('../app/dashbaord/contribution-user-details/contribution-user-details.component').then(c => c.ContributionUserDetailsComponent) },
  {
    path: 'initiative-space', canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/initiative-space/initiative-space.component').then(c => c.InitiativeSpaceComponent)
      },
      {
        path: 'trust-delegation/contributors/list',
        loadComponent: () => import('../app/dashbaord/trust-delegation-space/trust-delegation-contributors/trust-delegation-contributors.component').then(c => c.TrustDelegationContributorsComponent)
      },
      {
        path: 'trust-delegation/:wallet/:id/:type',
        loadComponent: () => import('../app/dashbaord/trust-delegation-space/trust-delegation-space.component').then(c => c.TrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet',
        loadComponent: () => import('../app/dashbaord/trust-delegation-space/trust-delegation-space.component').then(c => c.TrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet/:id',
        loadComponent: () => import('../app/dashbaord/trust-delegation-space/trust-delegation-space.component').then(c => c.TrustDelegationSpaceComponent)
      }

    ]
  },
  // {
  //   path: 'bug-bounty',
  //   children: [
  //     {
  //       path: '',
  //       loadComponent: () => import('../app/dashbaord/bug-bounty/bug-bounty-landing-page/bug-bounty-landing-page.component').then(c => c.BugBountyLandingPageComponent)
  //     },
  //     {
  //       path: 'participation',
  //       canActivate:[BugBountyNoAuthGuard],
  //       loadComponent: () => import('../app/dashbaord/bug-bounty/bug-bounty-participation-form/bug-bounty-participation-form.component').then(c => c.BugBountyParticipationFormComponent)
  //     },
  //     {
  //       path: 'form',
  //       canActivate:[BugBountyAuthGuard],
  //       loadComponent: () => import('../app/dashbaord/bug-bounty/bug-bounty-form/bug-bounty-form.component').then(c => c.BugBountyFormComponent)
  //     }
  //   ]

  // },
  {
    path: 'booking-kit',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/booking-kit/booking-kit.component').then(c => c.BookingKitComponent)
      },
      {
        path: 'form',
        loadComponent: () => import('../app/dashbaord/booking-kit/booking-kit-form/booking-kit-form.component').then(c => c.BookingKitFormComponent)
      }
    ]
  },
  {
    path: 'initiative-space/internal-id', canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/initiative-space/internal-id-initiatitive/internal-id-space/internal-id-space.component').then(c => c.InternalIdSpaceComponent)
      },
      {
        path: 'trust-delegation/contributors/list',
        loadComponent: () => import('../app/dashbaord/trust-delegation-space/internal-id-trust-delegation/internal-id-delegation-contributors/internal-id-delegation-contributors.component').then(c => c.InternalIdDelegationContributorsComponent)
      },
      {
        path: 'trust-delegation/:wallet/:id/:type',
        loadComponent: () => import('../app/dashbaord/trust-delegation-space/internal-id-trust-delegation/internal-id-trust-delegation-space/internal-id-trust-delegation-space.component').then(c => c.InternalIdTrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet',
        loadComponent: () => import('../app/dashbaord/trust-delegation-space/internal-id-trust-delegation/internal-id-trust-delegation-space/internal-id-trust-delegation-space.component').then(c => c.InternalIdTrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet/:id',
        loadComponent: () => import('../app/dashbaord/trust-delegation-space/internal-id-trust-delegation/internal-id-trust-delegation-space/internal-id-trust-delegation-space.component').then(c => c.InternalIdTrustDelegationSpaceComponent)
      }

    ]
  },
  {
    path: 'initiative-space/aggressive-marketing', canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/aggressive-marketing/aggressive-marketing-initiative/aggressive-marketing-initiative-space/aggressive-marketing-initiative-space.component').then(c => c.AggressiveMarketingInitiativeSpaceComponent)
      },
      {
        path: 'trust-delegation/contributors/list',
        loadComponent: () => import('../app/dashbaord/aggressive-marketing/aggressive-marketing-trust-delegation-space/aggressive-marketing-delegation-contributors/aggressive-marketing-delegation-contributors.component').then(c => c.AggressiveMarketingDelegationContributorsComponent)
      },
      {
        path: 'trust-delegation/:wallet/:id/:type',
        loadComponent: () => import('../app/dashbaord/aggressive-marketing/aggressive-marketing-trust-delegation-space/aggressive-marketing-trust-delegation-space.component').then(c => c.AggressiveMarketingTrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet',
        loadComponent: () => import('../app/dashbaord/aggressive-marketing/aggressive-marketing-trust-delegation-space/aggressive-marketing-trust-delegation-space.component').then(c => c.AggressiveMarketingTrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet/:id',
        loadComponent: () => import('../app/dashbaord/aggressive-marketing/aggressive-marketing-trust-delegation-space/aggressive-marketing-trust-delegation-space.component').then(c => c.AggressiveMarketingTrustDelegationSpaceComponent)
      }

    ]
  },
  {
    path: 'aggressive-dashboard',
    canActivate: [AuthGuard],
    loadComponent: () => import('../app/dashbaord/aggressive-dashboard/aggressive-dashboard.component').then(c => c.AggressiveDashboardComponent)
  },
  {
    path: 'saf-contribution',
    canActivate: [AuthGuard, SAFAuthGuard],
    loadComponent: () => import('../app/dashbaord/saf-contribution/saf-contribution.component').then(c => c.SafContributionComponent)
  },
  // {
  //   path: 'saf-dashboard',
  //   loadComponent: () => import('../app/dashbaord/saf-contribution/saf-dashboard/saf-dashboard.component').then(c => c.SafDashboardComponent)
  // },
  {
    path: 'saf-initiative-space', canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/saf-initiative-space/saf-initiative-space.component').then(c => c.SafInitiativeSpaceComponent)
      },
      {
        path: 'trust-delegation/contributors/list',
        loadComponent: () => import('../app/dashbaord/saf-initiative-space/saf-trust-delegation-space/saf-trust-delegation-contributors/saf-trust-delegation-contributors.component').then(c => c.SafTrustDelegationContributorsComponent)
      },
      {
        path: 'trust-delegation/:wallet',
        loadComponent: () => import('../app/dashbaord/saf-initiative-space/saf-trust-delegation-space/saf-trust-delegation-space.component').then(c => c.SafTrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet/:type',
        loadComponent: () => import('../app/dashbaord/saf-initiative-space/saf-trust-delegation-space/saf-trust-delegation-space.component').then(c => c.SafTrustDelegationSpaceComponent)
      }
    ]

  },
  {
    // AuthGuard first: SAFAuthGuard only checks the client-set `isAfricaUser` eligibility flag and
    // never looks at the session token, so on its own it gates nothing. Same pairing as
    // `saf-contribution` above. Guards on this parent cover every child route below.
    path: 'post-saf-initiative-space', canActivate: [AuthGuard, SAFAuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/post-saf-initiative-space/post-saf-initiative-space-selector/post-saf-initiative-space-selector.component').then(c => c.PostSafInitiativeSpaceSelectorComponent)
      },
      {
        path: ':category',
        loadComponent: () => import('../app/dashbaord/post-saf-initiative-space/post-saf-initiative-personal-space/post-saf-initiative-personal-space.component').then(c => c.PostSafInitiativePersonalSpaceComponent)
      },
      {
        path: ':category/trust-delegation/contributors/list',
        loadComponent: () => import('../app/dashbaord/post-saf-initiative-space/post-saf-trust-delegation-space/post-saf-trust-delegation-contributors/post-saf-trust-delegation-contributors.component').then(c => c.PostSafTrustDelegationContributorsComponent)
      },
      {
        path: ':category/trust-delegation/:wallet',
        loadComponent: () => import('../app/dashbaord/post-saf-initiative-space/post-saf-trust-delegation-space/post-saf-trust-delegation-space.component').then(c => c.PostSafTrustDelegationSpaceComponent)
      },
      {
        path: ':category/trust-delegation/:wallet/:type',
        loadComponent: () => import('../app/dashbaord/post-saf-initiative-space/post-saf-trust-delegation-space/post-saf-trust-delegation-space.component').then(c => c.PostSafTrustDelegationSpaceComponent)
      }
    ]
  },
  {
    path: 'initiative-54-space',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/initiative-54-space/initiative-54-space.component').then(c => c.Initiative54SpaceComponent)
      },
      {
        path: 'trust-delegation/contributors/list',
        loadComponent: () => import('../app/dashbaord/initiative-54-space/initiative-54-trust-delegation/initiative-54-trust-delegation-contributors/initiative-54-trust-delegation-contributors.component').then(c => c.Initiative54TrustDelegationContributorsComponent)
      },
      {
        path: 'trust-delegation/:wallet/:id/:type',
        loadComponent: () => import('../app/dashbaord/initiative-54-space/initiative-54-trust-delegation/initiative-54-trust-delegation-space.component').then(c => c.Initiative54TrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet',
        loadComponent: () => import('../app/dashbaord/initiative-54-space/initiative-54-trust-delegation/initiative-54-trust-delegation-space.component').then(c => c.Initiative54TrustDelegationSpaceComponent)
      },
      {
        path: 'trust-delegation/:wallet/:id',
        loadComponent: () => import('../app/dashbaord/initiative-54-space/initiative-54-trust-delegation/initiative-54-trust-delegation-space.component').then(c => c.Initiative54TrustDelegationSpaceComponent)
      }
    ]
  },
  {
    path: 'rapture-initiative-space',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('../app/dashbaord/rapture-initiative-space/rapture-initiative-space.component').then(c => c.RaptureInitiativeSpaceComponent)
      },
      {
        path: 'rapture-trust-delegation/contributors/list',
        loadComponent: () => import('../app/dashbaord/rapture-initiative-space/rapture-trust-delegation-space/rapture-trust-delegation-contributors/rapture-trust-delegation-contributors.component').then(c => c.RaptureTrustDelegationContributorsComponent)
      },
      {
        path: 'rapture-trust-delegation/:wallet/:id/:type',
        loadComponent: () => import('../app/dashbaord/rapture-initiative-space/rapture-trust-delegation-space/rapture-trust-delegation-space.component').then(c => c.RaptureTrustDelegationSpaceComponent)
      },
      {
        path: 'rapture-trust-delegation/:wallet',
        loadComponent: () => import('../app/dashbaord/rapture-initiative-space/rapture-trust-delegation-space/rapture-trust-delegation-space.component').then(c => c.RaptureTrustDelegationSpaceComponent)
      },
      {
        path: 'rapture-trust-delegation/:wallet/:id',
        loadComponent: () => import('../app/dashbaord/rapture-initiative-space/rapture-trust-delegation-space/rapture-trust-delegation-space.component').then(c => c.RaptureTrustDelegationSpaceComponent)
      }
    ]
  },
  { path: 'coming-soon', loadComponent: () => import('../app/coming-soon/coming-soon.component').then(c => c.ComingSoonComponent) },
  { path: 'mfeg', loadComponent: () => import('../app/shared/component/mfeg/mfeg.component').then(c => c.MfegPageComponent) },
  { path: 'warnings-and-caution', loadComponent: () => import('../app/shared/component/terms-and-conditions-new/warning-content-new/warning-content-new.component').then(c => c.WarningContentNewComponent) },
  { path: '**', loadComponent: () => import('../app/shared/component/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent) } // Wildcard route for 404

];